import React, { useCallback, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { fetchLogin } from '@/store/auth/actions';

// Component that renders a native <form> for initiating the flow for connecting with Gmail.
// At least 1 submit button (which submits the form) is expected to be provided as `children` to this component.
// Example:
//   <ConnectWithGmailForm user={user}>
//     <Button type="submit" variant="primary">
//       Connect
//     </Button>
//   </ConnectWithGmailForm>
//
export function ConnectWithGmailForm({ user, children, dispatch }) {
  const [csrfToken, setCsrfToken] = useState('');

  const onSubmit = useCallback(
    async (event) => {
      const form = event?.target;

      // proceed with normal submit if CSRF token is already there
      if (form.elements['authenticity_token']?.value) return;

      // otherwise, fetch the CSRF token, attach it to the form, then submit
      event.preventDefault();

      const { data = {} } = await dispatch(fetchLogin()).unwrap();
      const { csrf_token } = data;
      if (csrf_token) {
        setCsrfToken(csrf_token);
        setTimeout(() => form.submit());
      }
    },
    [setCsrfToken, dispatch]
  );

  const { tFeGoogleIncrementalScopes } = useFlags();

  const googleOauthParams = new URLSearchParams({
    for: 'gmail',
    origin: window.location.href,
  });

  if (!tFeGoogleIncrementalScopes) {
    googleOauthParams.delete('for'); // revert to old behaviour
  }

  return (
    <form
      method="post"
      action={`/api/v1/auth/google_oauth2?${googleOauthParams}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <input type="hidden" name="login_hint" value={user?.email || ''} />
      {children}
    </form>
  );
}
